function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Icon } from "../icon";
import { Colors } from "./Chip.colors";
import { leftIconSizes, rightIconSizes } from "./Chip.styles";
import { Tone } from "./Chip.types";
import { ClickableHoverableWrapper } from "./ClickableHoverableWrapper";
export var ChipIcon = function ChipIcon(_ref) {
  var icon = _ref.icon,
      palette = _ref.palette,
      size = _ref.size,
      hovered = _ref.hovered;
  return /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    color: hovered ? Colors[Tone.light][palette].iconMouseOverColor : Colors[Tone.light][palette].iconColor,
    size: size
  });
};
export var ChipLeftIcon = function ChipLeftIcon(_ref2) {
  var icon = _ref2.icon,
      palette = _ref2.palette,
      size = _ref2.size;
  return /*#__PURE__*/React.createElement(ChipIcon, {
    icon: icon,
    palette: palette,
    size: leftIconSizes[size]
  });
};
export var ChipRightIcon = function ChipRightIcon(_ref3) {
  var icon = _ref3.icon,
      palette = _ref3.palette,
      size = _ref3.size,
      _ref3$hovered = _ref3.hovered,
      hovered = _ref3$hovered === void 0 ? false : _ref3$hovered;
  return /*#__PURE__*/React.createElement(ChipIcon, {
    icon: icon,
    palette: palette,
    size: rightIconSizes[size],
    hovered: hovered
  });
};
export var ClickableIcon = function ClickableIcon(_ref4) {
  var icon = _ref4.icon,
      size = _ref4.size,
      palette = _ref4.palette,
      onClick = _ref4.onClick;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hovered = _React$useState2[0],
      setHovered = _React$useState2[1];

  return /*#__PURE__*/React.createElement(ClickableHoverableWrapper, {
    onClick: onClick,
    onMouseOver: function onMouseOver() {
      return setHovered(true);
    },
    onMouseOut: function onMouseOut() {
      return setHovered(false);
    }
  }, /*#__PURE__*/React.createElement(ChipRightIcon, {
    icon: icon,
    palette: palette,
    size: size,
    hovered: onClick ? hovered : false
  }));
};